<div class="language-selector-container">
  <div *ngFor="let language of languageService.getLanguages(); trackBy: languageTrackBy">
    <div class="language-description"
      [class.selected]="language.language === (languageService.selectedLanguage$ | async)?.language"
      (click)="selectLanguage(language.language)" analytics [click]='true' [category]="'Change Language'"
      [label]="'Language: ' + language.language">
      {{ language.languageDescription }}
    </div>
  </div>
</div>